import { render, staticRenderFns } from "./platformCountV2.vue?vue&type=template&id=04b8ca00"
import script from "./platformCountV2.vue?vue&type=script&lang=js"
export * from "./platformCountV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports